module.exports = __webpack_public_path__ + "img/consob-no-bg.9076b8cb.png";